module.exports = __webpack_public_path__ + "static/media/cape-cod-5.dc043419.jpg";